<template>
  <div class="featuresSection">
    <!-- Features-Section-Start -->
    <section class="row_am features_section" id="features">
      <!-- container start -->
      <div class="container">
        <div
          class="section_title"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="100"
        >
          <!-- h2 -->
          <h2><span>WHY </span> SALT</h2>
          <!-- p -->
          <p>
            Salt is built to simplify braiding services—for both customers and professionals—without back-and-forth or hidden costs.
          </p>
        </div>
        <div class="feature_detail">
          <!-- feature box left -->
          <div class="left_data feature_box">
            <!-- feature box -->
            <div
              class="data_block"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="icon">
                <img src="images/secure_data03.png" alt="image" />
              </div>
              <div class="text">
                <h4>Secure Payments</h4>
                <p>
                  Book with confidence using safe and transparent online payments. No surprises, no cash hassle.
                </p>
              </div>
            </div>

            <!-- feature box -->
            <div
              class="data_block"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="icon">
                <img src="images/functional02.png" alt="image" />
              </div>
              <div class="text">
                <h4>Fully Functional Booking</h4>
                <p>
                  Select braid type, size, length, date, time, and stylist—all in one smooth flow.
                </p>
              </div>
            </div>
          </div>

          <!-- feature box right -->
          <div class="right_data feature_box">
            <!-- feature box -->
            <div
              class="data_block"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="icon">
                <img src="images/live-chat02.png" alt="image" />
              </div>
              <div class="text">
                <h4>In-App Live Chat</h4>
                <p>
                 Chat directly with your stylist before or after booking to confirm details and preferences.
                </p>
              </div>
            </div>

            <!-- feature box -->
            <div
              class="data_block"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="icon">
                <img src="images/support03.png" alt="image" />
              </div>
              <div class="text">
                <h4>24-7 Support</h4>
                <p>
                  Our support team is always here to help keep your experience smooth and stress-free.
                </p>
              </div>
            </div>
          </div>
          <!-- feature image -->
          <div
            class="feature_img"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <img src="images/features_frame03.png" alt="image" />
          </div>
        </div>
      </div>
      <!-- container end -->
    </section>
    <!-- Features-Section-end -->
  </div>
</template>

<script>
export default {
  name: "FeaturesSection",
};
</script>
